import React from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'
import {FormId_ContactTech , CLIENT_ID} from '../config.js'
import GetForm from './GetForm'
import { getItemAnonymous} from '../actions/user'
import { connect } from 'react-redux';
import {GET_FORM, SUBMIT_FORM,CREATE_FORM_ENTRIE} from '../actions/user';
import { UncontrolledAlert } from 'reactstrap';
import  Sidebar from "./Sidebar";

class ContactTech extends React.Component {
constructor(props){
  super(props);
  this.state={
    spinner_status:false,
  }
}
componentDidMount(){
    const url ='v1/forms/'+FormId_ContactTech+'/view/?client='+CLIENT_ID;
    this.setState({spinner_status:true});
    this.props.getItemAnonymous(url, GET_FORM);
  }
componentWillReceiveProps(nextProps) {
    this.setState({spinner_status:nextProps.spinner_status});
 }
    render() {
      const success  = this.props.success ? this.props.success :null;
      console.log('test mes' , {success});
    return (
	<div>
<section className="inner-intro bg-image  parallax parallax-background1 inner_page_background" style={{backgroundImage:'url("/assets/img/images/branding/pmg5.jpg")'}}>
            <div className="container">
                <div className="row title">
                    <h2 className="h2">Green Agro Business</h2>
                    <div className="page-breadcrumb">
                        <a>Nos services</a>/<span>Demander un technicien</span>
                    </div>
                </div>
            </div>
        </section> 


        <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane page_info">
                <div className="row text-center inside_content">
                  <div className="col-md-8">

                 <h3 className="search_inno"><img src="/assets/img/leaf.png" className="leaf-sidebar"/> Demander un technicien</h3>
                 <h6 className="search_tech">Contacter un technicien conseil :<br/><a className=" conseil_tech_phone"><i className="fa fa-phone left"></i>+221 33 825 74 44</a></h6>


                    
                     {this.props.success ?
                      <UncontrolledAlert color="success">
                          {this.props.success}
                      </UncontrolledAlert>
                      :
                      this.props.error ?
                        <UncontrolledAlert color="danger">
                           {this.props.error}
                      </UncontrolledAlert>
                        : null
                    
                    }


                        <GetForm fields={this.props.fields} title={this.props.title} 
                        formId={FormId_ContactTech} clientId={CLIENT_ID} spinner_status={this.state.spinner_status}
                        textbtn="Envoyer votre message"/>
                     
                       
                    </div>
                       
                   
                    <Sidebar/>           
                  </div>
                    </div>
                
              
            
        
        </section>




    </div>


  )
 }
}
function mapStateToProps(state, ownProps){
  return {
    fields: state.dynamicform.fields,
    title: state.dynamicform.title,
    success: state.dynamicform.success,
    error: state.dynamicform.error,
    spinner_status:state.dynamicform.spinner_status,

  }
}  
export default connect(mapStateToProps, {getItemAnonymous})(ContactTech);




// WEBPACK FOOTER //
// ./src/components/ContactTech.jsx